import {andThen, Decoder, fail, field, string, succeed} from 'json-bouncer'

export type M =
    | PasswordWrong
    | PasswordChanged

export interface PasswordWrong {
    readonly type: 'PasswordWrong'
}

export interface PasswordChanged {
    readonly type: 'PasswordChanged'
}

export function decoder(): Decoder<M> {
    return andThen(
        (error: string): Decoder<M> => {
            switch (error) {
                case 'PasswordWrong':
                    return succeed<M>({type: 'PasswordWrong'})
                case 'PasswordChanged':
                    return succeed<M>({type: 'PasswordChanged'})
                default:
                    return fail(`Unexpected status message: ${error}`)
            }
        },
        field('status', string()),
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/PasswordChangeResponse.ts